<template>
  <main class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="card-title d-flex justify-content-between align-items-center">
          <h6>شبکه های فروش</h6>
        </div>
        <div class="row slick-single-item">
          <div class="col-xl-3 col-lg-6 col-lg-6 col-sm-12">
            <div class="card border mb-0">
              <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                  <div>
                    <div class="icon-block icon-block-sm bg-danger icon-block-floating mr-2">
                      <em class="fa fa-money"></em>
                    </div>
                  </div>
                  <router-link v-if="can('ticket')" :to="{ name:'ticket'}" class="font-size-20 text-dark">تیکت</router-link>
                  <h2 class="mb-0 ml-auto font-weight-bold text-danger primary-font line-height-30">{{ticketCount}}</h2>
                </div>
                <div class="progress" style="height: 5px">
                  <div class="progress-bar bg-danger" role="progressbar" style="width: 71%" aria-valuenow="71"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-lg-6 col-sm-12">
            <div class="card border mb-0">
              <div class="card-body">
                <div class="d-flex align-items-center mb-3">
                  <div>
                    <div class="icon-block icon-block-sm bg-success icon-block-floating mr-2">
                      <em class="fa fa-globe"></em>
                    </div>
                  </div>
                  <router-link v-if="can('projects.index')" :to="{ name:'projects.index'}" class="font-size-20 text-dark">کل پروژه ها</router-link>
                  <a v-else class="font-size-20 text-dark">کل پروژه ها</a>
                  <h2 class="mb-0 ml-auto font-weight-bold text-success primary-font line-height-30">{{projectCount}}</h2>
                </div>
                <div class="progress" style="height: 5px">
                  <div class="progress-bar bg-success" role="progressbar" style="width: 39%" aria-valuenow="39"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-lg-6 col-sm-12">
            <div class="card border mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <div class="icon-block icon-block-sm bg-info icon-block-floating mr-2">
                      <em class="fa fa-user"></em>
                    </div>
                  </div>
                  <router-link v-if="can('projects.index')" :to="{ name:'projects.index'}" class="font-size-20 text-dark">پروژه های درحال اجرا</router-link>
                   <a v-else class="font-size-20 text-dark">پروژه های درحال اجرا</a>
                  <h2 class="mb-0 ml-auto font-weight-bold text-info primary-font line-height-30">{{materialCount}}</h2>
                </div>
                <div class="progress" style="height: 5px">
                  <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-lg-6 col-sm-12">
            <div class="card border mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <div class="icon-block icon-block-sm bg-facebook icon-block-floating mr-2">
                      <em class="fa fa-users"></em>
                    </div>
                  </div>
                  <router-link v-if="can('staff.index')" :to="{ name: 'staff.index' }" class="font-size-20">کارمندان</router-link>
                  <a v-else class="font-size-20 text-dark">کارمندان</a>
                  <h2 class="mb-0 ml-auto font-weight-bold text-facebook primary-font line-height-30">{{staffCount}}</h2>
                </div>
                <div class="progress" style="height: 5px">
                  <div class="progress-bar bg-facebook" role="progressbar" style="width: 50%" aria-valuenow="50"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      projectCount: 0,
      ticketCount: 0,
      staffCount: 0,
      materialCount: 0
    }
  },
  mounted () {
    this.$send.submit('get', 'api/dashboard')
      .then(response => {
        this.projectCount = response.projectCount
        this.ticketCount = response.ticketCount
        this.staffCount = response.staffCount
        this.materialCount = response.materialCount
      })
  }

}

</script>
